// Vendored copy of src/_src_shared/utils/functions/formatSsn.js — kept here so
// the tpo subtree stays self-contained, the same way formatDate / formatDollar /
// formatPhone are. Keep the two in step if either changes.
export const formatSsn = (value, showSsn) => {
  if (!value) return "";
  const digits = String(value).replace(/[^\d]/g, "");

  if (showSsn) {
    // Show dashes only if showSsn is true
    if (digits.length <= 3) return digits;
    if (digits.length <= 5) {
      return digits.slice(0, 3) + "-" + digits.slice(3);
    }
    return digits.slice(0, 3) + "-" + digits.slice(3, 5) + "-" + digits.slice(5);
  }
  // If hidden, remove dashes so a password field is only as long as the digits
  return digits;
};

export default formatSsn;
